import { Navigation } from './components/Navigation';
import './styles/app.css';

export const App = () => <Navigation/>